/**
 * 붙여넣은 HTML(예: 브라우저 dev-tools 'Copy element') 에서 사람이 보는 텍스트만 남긴다.
 * 태그가 없으면 원문 유지. 입력(paste)·표시(리스트 요약·상세 본문) 양쪽에서 사용 — 기존 저장 데이터도 렌더 시 정리.
 * (navido d80a434 · 2026-09-20)
 */
export const stripHtmlToText = (raw: string): string => {
  if (!raw || !/<[a-z][^>]*>/i.test(raw)) return raw;
  try {
    const doc = new DOMParser().parseFromString(raw, 'text/html');
    // <select>/<option> 는 textContent 가 옵션 텍스트를 공백 없이 이어붙이므로 공백 삽입.
    doc.querySelectorAll('option, br').forEach((el) => el.append(' '));
    return (doc.body?.textContent || '').replace(/[ \t]+/g, ' ').replace(/\s*\n\s*/g, '\n').trim();
  } catch {
    return raw.replace(/<[^>]+>/g, '').trim();
  }
};
